import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Thank_you from "./components/thank-you/Thank_you";
import ScrollToTop from "./components/scrolltotop/ScrolltoTop";
import WhatsappChatbot from "./components/common_components/whatsapp_chatbot/WhatsappChatbot";

function App() {
  return (
    <>
      <ScrollToTop />
      <WhatsappChatbot />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/programs" element={<Home />} />
        <Route path="/admission_process" element={<Home />} />
        <Route path="/eligibility-criteria" element={<Home />} />
        <Route path="/fee_structure" element={<Home />} />
        <Route path="/thank-you" element={<Thank_you />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
